import { NavLink } from 'react-router-dom';
import { IProject } from '../../planner-interfaces';
import { DragEvent } from 'react';
import { showToast } from '../../../../common/domain/toast-provider';
import { dragTodoToProject } from '../../data/planner-data-service';
import ProjectMenuDragButton from './drag/project-menu-drag-btn';
import { closeMobileMenu } from '../../../../menu/ui/mobile-menu-provider';
import { combineProjectData } from '../../domain/planner-provider';
import { markdown2Html } from '../../../../common/markdown/markdown-provider';
import { usePlannerStore } from '../../data/planner-store';

interface IProjectMenuItemProps {
    project: IProject;
}

const DRAG_CLASS_NAME = 'project__drag-target__over';

const ProjectMenuItem = ({ project }: IProjectMenuItemProps) => {

    const setCombinedProject = usePlannerStore(state => state.setCombinedProject);

    const targetOnDragOver = (evt: DragEvent<HTMLAnchorElement>) => {
        evt.preventDefault();
    };

    const targetOnDragEnter = (evt: DragEvent<HTMLAnchorElement>) => {
        evt.currentTarget.classList.add(DRAG_CLASS_NAME);
    };

    const targetOnDragLeave = (evt: DragEvent<HTMLAnchorElement>) => {
        evt.currentTarget.classList.remove(DRAG_CLASS_NAME);
    };

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setData
     */
    const targetOnDrop = async (evt: DragEvent<HTMLAnchorElement>) => {
        evt.currentTarget.classList.remove(DRAG_CLASS_NAME);
        evt.preventDefault();
        const data = evt.dataTransfer.getData('text');

        if(data === null ||
            data === undefined ||
            data.trim() === '' ||
            isNaN(Number(data))) {
            showToast('Drop task error.');
            return;
        }

        const sourceTodoId = Number(data);
        const new_project_id = project.project_id;
        console.log(`todo (${ sourceTodoId }): to ${ new_project_id })`);

        const response = await dragTodoToProject(
            new_project_id,
            sourceTodoId,
        );

        if(!response) {
            showToast('Drag task to project error.');
            return;
        }

        setCombinedProject(combineProjectData(response));
    };

    return (
        <NavLink
            onClick={ closeMobileMenu }
            onDragOver={ targetOnDragOver }
            onDragEnter={ targetOnDragEnter }
            onDragLeave={ targetOnDragLeave }
            onDrop={ targetOnDrop }
            to={ `/planner/${ project.project_id }` }
            className="project__menu-item flex border-b border-slate-700 py-2 flex items-center whitespace-pre-wrap">

            <ProjectMenuDragButton project={ project } />

            <div
                className="flex"
                dangerouslySetInnerHTML={{__html: markdown2Html(project.project_title) }}
            />
        </NavLink>
    )
};

export default ProjectMenuItem;